import type { AccordionProps as Props } from './types';
import { cls } from '@/utils/cls';
import style from './Accordion.module.scss';
import RichText from '../RichText';
import Disclosure from './_partials/Disclosure';
export default function Accordion({
  extendStyles,
  heading,
  tabs
}: Props) {
  const _className = cls(style.root, extendStyles);
  return <div className={_className} data-sentry-component="Accordion" data-sentry-source-file="Accordion.tsx">
			<div className={style.content}>
				<RichText text={heading} className={style.heading} data-sentry-element="RichText" data-sentry-source-file="Accordion.tsx" />
				<div className={style.tabs}>
					{tabs.map((tab, i) => <Disclosure key={`accordion-tab-${i}`} question={tab.question} answer={tab.answer} />)}
				</div>
			</div>
		</div>;
}